<template>
    <StepContainer>
        <div class="name">请选择转服游戏：</div>
        <ul class="game-list">
            <li v-for="(game, key) in sharedState.gameList" :key="key" :name="key" @click="toStep2(game.app)">
                <div class="logo" :style="{'background-image': `url(${game.img_url})`}"></div>
                <div class="des">
                    <div class="name">《{{game.cname}}》</div>
                    <div class="style">{{game.style}}</div>
                </div>
            </li>
        </ul>
    </StepContainer>
</template>

<script>
import StepContainer from '@/views/step-container';
import store from '@/store';

export default {
    components: {
        StepContainer
    },
    data () {
        return {
            gameList: [],
            sharedState: store.state
        }
    },
    methods: {
        toStep2(game) {
            this.$router.push({path: '/step2', query: {app: game}})
        },
    }
}
</script>

<style lang="scss">
.game-list {
    padding-top: 10px;
    overflow: hidden;
    li {
        float: left;
        width: 50%;
        display: flex;
        justify-content: flex-start;
        margin: 20px 0;
        cursor: pointer;
        .logo {
            width: 85px;
            height: 85px;
            border-radius: 10px;
            margin-right: 25px;
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
        }
        .des {
            padding-top: 10px;
            .style {
                font-size: 14px;
                color: #ccc;
                margin-top: 5px;
            }
        }
    }
}

@media screen and (max-width: 768px) {
    .game-list {
        li {
            height: 150px;
            display: block;
            margin: 5px 0;
            text-align: center;
            .logo {
                margin: 0 auto;
            }
        }
    }
}
</style>